import { render, staticRenderFns } from "./getMentor.vue?vue&type=template&id=2c5a7837&"
import script from "./getMentor.vue?vue&type=script&lang=js&"
export * from "./getMentor.vue?vue&type=script&lang=js&"
import style0 from "./getMentor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports